import { render, staticRenderFns } from "./EmergenzaViewComponent.vue?vue&type=template&id=119a4011"
import script from "./EmergenzaViewComponent.vue?vue&type=script&lang=js"
export * from "./EmergenzaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports